import { Box, Container, Typography } from '@mui/material'
import { Link } from 'react-router-dom'

const Footer = () => {
  return (
    <Box
      component='footer'
      sx={{
        position: 'relative',
        zIndex: 1,
        mt: 'auto',
        py: 3,
        px: 2,
        borderTop: '1px solid rgba(255, 255, 255, 0.08)',
        background: 'rgba(0, 0, 0, 0.5)',
        backdropFilter: 'blur(8px)',
      }}
    >
      <Container maxWidth='lg'>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 3, flexWrap: 'wrap' }}>
          <Typography variant='body2' sx={{ color: 'rgba(255,255,255,0.6)' }}>
            © {new Date().getFullYear()} 3Knots. All rights reserved.
          </Typography>
          <Typography
            component={Link}
            to='/privacy-policy'
            variant='body2'
            sx={{ color: 'rgba(255,255,255,0.6)', textDecoration: 'none', '&:hover': { color: '#fff' } }}
          >
            Privacy Policy
          </Typography>
          <Typography
            component={Link}
            to='/terms-and-conditions'
            variant='body2'
            sx={{ color: 'rgba(255,255,255,0.6)', textDecoration: 'none', '&:hover': { color: '#fff' } }}
          >
            Terms and Conditions
          </Typography>
        </Box>
      </Container>
    </Box>
  )
}

export default Footer
